import ThailandAutoComplete from 'vue-thailand-address-autocomplete'
import api from '../../services/service_item'
export default {
  components: {
    ThailandAutoComplete
  },
  data () {
    return {
      search_keyword: '',
      title: 'รายการส่งคืนสินค้า',
      search: '',
      currentPage: 1,
      items_perpage: 10,
      active: 1,
      modal_active: false,
      modal_data: {
        name: '',
        credit_day: 0,
        debt_limit: 0,
        debt_balance: 0,
        telephone: '',
        address: '',
        sub_district: '',
        district: '',
        province: '',
        zipcode: '',
        active_status: ''
      },
      modal_title: '',
      data_list: [],
      menu_active: 0,
      menus: [
        {name: 'menu1'},
        {name: 'menu2'},
        {name: 'menu3'},
        {name: 'menu4'},
        {name: 'menu5'}
      ],
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      group: [],
      data_list_group: []
    }
  },
  computed: {
    filterData: function () {
      let text = this.search.trim()
      this.currentPage = 1
      return this.data_list.filter(items => {
        return (
          items.doc_no.indexOf(text) > -1
        )
      })
    },
    paginate: function () {
      this.totalItem = this.filterData.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.filterData.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.active = pageNumber
    },
    goToPage (code) {
      this.$store.state.historyPage = this.$route.path
      this.$router.push({ name: 'managestorage', params: { code: code } })
    },
    goToPageTest (path) {
      this.$store.state.historyPage = this.$route.path
      this.$router.push(path)
    },
    doing () {
      alert('รอดำเนินการ')
    },
    select (address) {
      this.modal_data.sub_district = address.district
      this.modal_data.district = address.amphoe
      this.modal_data.province = address.province
      this.modal_data.zipcode = address.zipcode
    },
    close_modal () {
      this.modal_active = false
      this.modal_data = {
        name: '',
        credit_day: 0,
        debt_balance: 0,
        telephone: '',
        address: '',
        sub_district: '',
        district: '',
        province: '',
        zipcode: '',
        active_status: ''
      }
    },
    getList () {
      this.$store.commit('Loading')
      api.listReceive(this.REST_URL,
        this.header,
        {
          'keyword': this.search_keyword,
          'limit': 500,
          'status': 2
        },
        result => {
          console.log(result)
          if (result.response === 'success') {
            this.data_list = result.data
          } else {
            this.$notification['warning']({
              message: 'ไม่พบข้อมูล'
            })
            this.data_list = []
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    editItem (val) {
      console.log(val.doc_no)
      this.goToPage(val.doc_no)
    },
    printBill () {
      this.$notification['error']({
        message: 'กำลังปรับปรุง'
      })
    },
    selectByGroup (index) {
      console.log(index)
      console.log(this.data_list_group[index].items)
      this.data_list = this.data_list_group[index].items
      if (this.data_list_group[index].items == null) {
        this.data_list = []
      } else {
        this.data_list = this.data_list_group[index].items
      }
    }
  },
  created () {
    this.$store.state.historyPage = ''
    this.checkUser()
  },
  mounted () {
    this.getList()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/return_list.js